/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Modal, Button } from '@atoms';
import { CampaignField } from '@molecules';
import Form from '@organisms/Form';

import { FORM_FIELD } from './constants';
import { useCampaign } from './hooks';
import s from './styles.module.less';

const CampaignModal = ({
  okText = 'ADD URL',
  cancelText = 'CANCEL',
  hide,
  type: shortcode,
  onSubmit,
  onCancel = hide,
  ...props
}) => {
  const [form] = Form.useForm();

  const handleOk = async (values) => {
    const campaign = values[FORM_FIELD.CAMPAIGN.name];
    onSubmit(`<a href="https://identity.worldathletics.org/registration?tag=${campaign.tag}">${campaign.name}</a>`);
    form.resetFields();
    hide();
  };

  const footer = (
    <>
      <Button key="submit" type="customBlue" onClick={form.submit}>
        {okText}
      </Button>

      <Button key="back" onClick={onCancel}>
        {cancelText}
      </Button>
    </>
  );

  return (
    <Modal footerDivider={false} footer={footer} title={null} className={s.custom} {...props} zIndex={1500}>
      <Form wrapperCol={{ span: 24 }} form={form} layout="vertical" onFinish={handleOk}>
        <CampaignField {...FORM_FIELD.CAMPAIGN} />
      </Form>
    </Modal>
  );
};

CampaignModal.useCampaign = useCampaign;

export default CampaignModal;
